import * as React from 'react';
import { TileLayout } from '@progress/kendo-react-layout';
import { MessagesTable } from '../components/messages/MessagesTable.jsx' 


export const Messages = () => {

   const [data, setData] = React.useState([
     {
       col: 1,
       colSpan: 4,
       rowSpan: 1,
     }
   ]);
   const tiles = [
     {
       header: 'Messages',
       body: <MessagesTable/>,
     }
   ];
   const handleReposition = (e) => {
     setData(e.value);
   };
   return (
     <TileLayout
       columns={4}
       positions={data}
       gap={{
         rows: 10,
         columns: 10,
       }}
       items={tiles}
       onReposition={handleReposition}
     />
   );
 };